import { PRFilterState } from 'src/sections/repository/sections/pull-request-list/types';

const PR_STATES = ['OPEN', 'MERGED', 'DECLINED', 'SUPERSEDED', 'DRAFT', 'ALL'];

export function buildStatesBBQL(states: PRFilterState[]): string {
  // Return early if the states array is empty or contains 'ALL'.
  // The API will return all PRs with an empty query string.
  if (states.length === 0 || states.includes('ALL')) {
    return '';
  }

  let showDraft: boolean = false;

  const statesSet = new Set<string>();
  for (const state of states) {
    if (PR_STATES.includes(state)) {
      if (state === 'DRAFT') {
        showDraft = true;
      } else {
        statesSet.add(`"${state}"`);
      }
    } else {
      // Return early if the state is invalid
      return '';
    }
  }

  let stateQuery = '';
  if (statesSet.size > 1) {
    // Multiple states -> 'state IN ("state1","state2", ...)'
    stateQuery = `state IN (${Array.from(statesSet).join(',')})`;
  } else if (statesSet.size === 1) {
    // Single state -> 'state="state1"'
    stateQuery = `state=${statesSet.values().next().value}`;
  }

  let draftQuery = '';
  // Context: state="OPEN" will return all open and draft PRs
  // If we intend to show both open and draft PRs, we don't need to add anything to the draftQuery.
  if (showDraft && !statesSet.has('"OPEN"')) {
    // This branch means we want to show draft PRs, but not open PRs.

    // Other states like "MERGED" and "DECLINED" have a value of draft=false.
    // So, we can't just append ' AND draft=true' to the stateQuery because it will exclude
    // those states.
    draftQuery =
      stateQuery.length > 0
        ? ' OR (state="OPEN" AND draft=true)'
        : 'state="OPEN" AND draft=true';
  } else if (!showDraft && statesSet.has('"OPEN"')) {
    // This branch means we want to show open PRs, but not draft PRs.
    draftQuery = ' AND draft=false';
  }

  return `${stateQuery}${draftQuery}`;
}
